import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() { }


  showLoader() {
    Swal.fire({
      imageUrl: './assets/img/loader.gif', 
      imageWidth: 86,                           
      imageHeight: 86,                      
      allowOutsideClick: false,
      showConfirmButton: false,
      background: 'transparent',          
      heightAuto: false,
      didOpen: () => {
      }
    });
  }
  async hideLoader() {
    Swal.close();
    setTimeout(() => Swal.close(), 1000);
  }
}
